import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/studio/m1-l.png'
import _imports_1 from '@/assets/images/studio/m1-r.png'
import _imports_2 from '@/assets/images/studio/m2-l.png'
import _imports_3 from '@/assets/images/studio/m2-m.png'
import _imports_4 from '@/assets/images/studio/m2-r.png'
import _imports_5 from '@/assets/images/studio/m4tupian1.png'
import _imports_6 from '@/assets/images/studio/m4tupian.png'
import _imports_7 from '@/assets/images/studio/m3-l-1.png'
import _imports_8 from '@/assets/images/studio/m3-l-2.png'
import _imports_9 from '@/assets/images/studio/m3-l-3.png'
import _imports_10 from '@/assets/images/studio/m3-r-t.png'
import _imports_11 from '@/assets/images/studio/m3-r-b.png'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "role-wrap" }
const _hoisted_4 = { class: "role-scene" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "role-title" }
const _hoisted_7 = { class: "role-title-tips" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "single-point" }
const _hoisted_10 = { class: "single-box" }
const _hoisted_11 = { class: "scene-type" }
const _hoisted_12 = { class: "scene-text" }
const _hoisted_13 = { class: "scene-content" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "spatial-recognition" }
const _hoisted_16 = { class: "item-show" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "solution" }
const _hoisted_19 = { class: "solution-content" }
const _hoisted_20 = { class: "title-tab" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "line"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "package" }
const _hoisted_28 = { class: "package-list" }

import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import ContactUs from '@/components/ContactUs2.vue'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioView',
  setup(__props) {

const loadUrl: any = ref({})
let videoDom: any = null;
const singlePointDataList = ref([
  {
    name: '平面AR',
    content: ['小程序扫描地面或者平面，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '图像AR',
    content: ['小程序扫描特定的图片，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '单场景AR',
    content: ['小程序扫描特定的单个小场景特征，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '身体AR',
    content: ['小程序扫描人的身体形态，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '人脸AR',
    content: ['小程序扫描人脸，', '识别后出现虚拟互动内容。'],
    url: ''
  },
  {
    name: '手势AR',
    content: ['小程序扫描张开的手掌，', '识别后出现虚拟互动内容。'],
    url: ''
  }
]);
const roleTextList = ref(
  [
    {
      title: '构建AR大场景',
      tips: 'SAAS化部署，无缝开发沉浸式世界里的增强现实内容，所有这些都在您的网络浏览器中创建和部署。',
      url: require('@/assets/images/home/room-platform.png'),
      activeClass: 'room-bg'
    },
    {
      title: 'XR眼镜端',
      tips: '通过账号进行登陆并选择相应场景进入相关展示内容。根据现场虚与实的融合进行体验。',
      url: require('@/assets/images/home/ar-rokid.png'),
      activeClass: 'glass-bg'
    },
    {
      title: '移动端',
      tips: '游客模式使用移动端混空Studio\nAPP或混空微信小程序进行空间互动体验(设备需支持ARkit/ARcore)。',
      url: loadUrl.value.web_platform,
      activeClass: 'web-bg'
    }
  ]
)
const activeRoleIndex = ref(0)
const solutionBannerList: any = ref(
  [
    {
      title: '空间数字化建图',
      content: ['多源采集：支持多种采集设备', '自研VPS定位：实现厘米级视觉定位精度','自研采集软件：空间瞬采，高效便捷'],
      url: require('@/assets/images/studio/solution-l-icon1.png'),
      a_url: require('@/assets/images/studio/solution-l-icon1A.png'),
    },
    {
      title: '智能场景创作',
      content: ['零代码，可视化操作', 'AI一键生成内容素材，创意无限', '20+类丰富素材，自由取用'],
      url: require('@/assets/images/studio/solution-l-icon2.png'),
      a_url: require('@/assets/images/studio/solution-l-icon2A.png'),
    },
    {
      title: '跨端部署',
      content: ['多形态交付：智能眼镜、手机等多端部署', '实时数据同步：可远程更新，内容动态迭代'],
      url: require('@/assets/images/studio/solution-l-icon3.png'),
      a_url: require('@/assets/images/studio/solution-l-icon3A.png'),
    },
    {
      title: '数实融合体验',
      content: ['多端体验数实融合互动场景'],
      url: require('@/assets/images/studio/solution-l-icon4.png'),
      a_url: require('@/assets/images/studio/solution-l-icon4A.png'),
    }
  ]
)
const solutionActiveIndex = ref(1)

let timer: any = null;
let lineStep = 1;

const toContact = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 605 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

const changeSolution = (index: number) => {
  solutionActiveIndex.value = index;
  tutorialCarousel()
}

const scrollEvent = () => {
  const screenRatio = (window.innerWidth / 1920);
  //m1
  const m1: any = document.querySelector('.advantage .m1');
  if (m1.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    (document.querySelector('.m1 .m1-img') as any).style.top = '33rem'
  }

  // m2
  const m2: any = document.querySelector('.advantage .m2');
  if (m2.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    (document.querySelector('.m2 .img1') as any).style.top = '19rem';
    (document.querySelector('.m2 .img2') as any).style.left = '94rem';
    (document.querySelector('.m2 .img3') as any).style.right = '72rem';
  }

  // m4
  const m4: any = document.querySelector('.advantage .m4');
  if (m4.getBoundingClientRect().top < window.innerHeight / 3 * 2) {
    const m4Img1 = document.querySelector('.m4 .img1') as any;
    const m4Img2 = document.querySelector('.m4 .img2') as any;
    const m4Img3 = document.querySelector('.m4 .img3') as any;
    
    if (m4Img1) m4Img1.style.top = '40rem';
    if (m4Img2) m4Img2.style.left = '30rem';
    if (m4Img3) m4Img3.style.right = '72rem';
  }

  // m3
  const m3: any = document.querySelector('.advantage .m3');
  const m3Top = m3.getBoundingClientRect().top
  const m3_r_child = document.querySelectorAll('.m3-r img');
  if (m3Top < window.innerHeight && m3Top > 0) {
    const offsetValue = (60 * screenRatio) * (m3Top / window.innerHeight);
    m3_r_child.forEach((e: any, i: number) => {
      if (i % 2) {
        e.style.marginLeft = -offsetValue + 'px'
      } else {
        e.style.marginLeft = offsetValue + 'px'
      }
    })
  }
}

const tutorialCarousel = () => {
  lineStep = 1;
  const line: any = document.querySelector('.solution-content .active .line');
  line.style.width = (380 / 5) * lineStep + 'rem';
  clearInterval(timer)
  timer = setInterval(() => {
    if (lineStep > 5) {
      solutionActiveIndex.value += 1;
      if (solutionActiveIndex.value > 3) {
        solutionActiveIndex.value = 0
      }
      lineStep = 1;

    }
    nextTick(() => {
      const line: any = document.querySelector('.solution-content .active .line');
      line.style.width = (380 / 5) * lineStep + 'rem';
      lineStep++;
    })

  }, 1050)
}

watch(() => solutionActiveIndex.value, (newState) => {
  if (solutionBannerList.value[newState].v_url) {
    videoDom = document.querySelectorAll('.explanation-video')[newState]?.children[0];
    videoDom.pause();
    setTimeout(() => {
      videoDom?.play();
    }, 200)
  }
})

onMounted(async () => {
  window.addEventListener('scroll', scrollEvent, false)
  tutorialCarousel()

  const vps_img: any = await asynchronousRetrieval('webimg/images/vps-img2.png');
  const web_platform: any = await asynchronousRetrieval('webimg/images/home/web-platform.png');
  const collect_maps: any = await asynchronousRetrieval('webimg/video/collect-maps.gif');
  const creating_scenes: any = await asynchronousRetrieval('webimg/video/creating-scenes.gif');
  const rapid_deployment: any = await asynchronousRetrieval('webimg/images/studio/rapid-deployment.png');
  const virtual_real_fusion: any = await asynchronousRetrieval('webimg/gif/virtual-real-fusion.gif');
  const glass_platform_bg: any = await asynchronousRetrieval('webimg/images/home/glass_platform_bg.png');
  const plane_recognition: any = await asynchronousRetrieval('webimg/images/studio/plane-recognition.gif');
  const hand_recognition: any = await asynchronousRetrieval('webimg/images/studio/hand-recognition.gif');
  const single_scene: any = await asynchronousRetrieval('webimg/images/studio/single-scene.gif');
  const body_recognition: any = await asynchronousRetrieval('webimg/images/studio/body-recognition.gif');
  const image_recognition: any = await asynchronousRetrieval('webimg/images/studio/image-recognition.gif');
  const face_recognition: any = await asynchronousRetrieval('webimg/images/studio/face-recognition.gif');
  const room_recognition: any = await asynchronousRetrieval('webimg/gif/room.gif');
  loadUrl.value = { vps_img, web_platform, collect_maps, creating_scenes, rapid_deployment, virtual_real_fusion, glass_platform_bg, hand_recognition, single_scene, body_recognition, image_recognition, face_recognition, room_recognition }

  roleTextList.value[2].url = web_platform;
  solutionBannerList.value[0].i_url = collect_maps;
  solutionBannerList.value[1].i_url = creating_scenes;
  solutionBannerList.value[2].i_url = rapid_deployment;
  solutionBannerList.value[3].i_url = virtual_real_fusion;
  singlePointDataList.value[0].url = plane_recognition;
  singlePointDataList.value[1].url = image_recognition;
  singlePointDataList.value[2].url = single_scene;
  singlePointDataList.value[3].url = body_recognition;
  singlePointDataList.value[4].url = face_recognition;
  singlePointDataList.value[5].url = hand_recognition;
})

onUnmounted(() => {
  clearInterval(timer)
  window.removeEventListener('scroll', scrollEvent, false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: loadUrl.value.vps_img
      }, null, 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"video-text\" data-v-8b1308b4><div class=\"logo-text\" data-v-8b1308b4><span data-v-8b1308b4>混空Studio</span></div><div class=\"link-room\" data-v-8b1308b4>AI+AR元宇宙内容创作与分发</div><a class=\"experience-now\" href=\"https://mixedspace.njyjxr.com\" data-v-8b1308b4><span data-v-8b1308b4>立即体验</span><div class=\"experience-btn\" data-v-8b1308b4></div></a></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "专业的元宇宙智能创作工具", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title-tips" }, "智能生成数字空间  智能创作工具链  跨端智能互动体验", -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleTextList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(activeRoleIndex.value == index ? item.activeClass : ''),
            onClick: ($event: any) => (activeRoleIndex.value = index)
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.tips), 1),
            _createElementVNode("img", {
              src: item.url,
              class: _normalizeClass(index == 1 ? 'rokid' : '')
            }, null, 10, _hoisted_8)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "多种识别方式，更灵活、更有趣", -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title-sub" }, "单点AR服务", -1)),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlePointDataList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, _toDisplayString(item.content[0]), 1),
                _createElementVNode("div", null, _toDisplayString(item.content[1]), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                (item.url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.url
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-sub" }, "空间AR服务", -1)),
        _createElementVNode("div", _hoisted_15, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "list-icon" }, "扫描空间特征"),
            _createElementVNode("div", { class: "list-icon" }, "识别成功后，在立体空间中出现虚拟"),
            _createElementVNode("div", null, "互动内容"),
            _createElementVNode("div", { class: "list-icon" }, "随着用户的位置移动展现出不同的内"),
            _createElementVNode("div", null, "容场景")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            (loadUrl.value.room_recognition)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: loadUrl.value.room_recognition
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"advantage\" data-v-8b1308b4><div class=\"title deep\" data-v-8b1308b4>我们的优势</div><div class=\"title-tips deep\" data-v-8b1308b4>更低的创作门槛，更丰富的功能</div><div class=\"m1\" data-v-8b1308b4><div data-v-8b1308b4><img class=\"m1-img\" src=\"" + _imports_0 + "\" data-v-8b1308b4><div class=\"t1\" data-v-8b1308b4>更准确的空间定位</div><div class=\"t2\" data-v-8b1308b4>自研空间定位算法，厘米级视觉定位空间导航精准， 支持大空间定位</div></div><div data-v-8b1308b4><img src=\"" + _imports_1 + "\" data-v-8b1308b4><div class=\"t1\" data-v-8b1308b4>更快速的交付部署</div><div class=\"t2\" data-v-8b1308b4>SaaS化服务快速调整内容布局</div><div class=\"t2\" data-v-8b1308b4>2天内完成空间构建现场体验式交付</div></div></div><div class=\"m2\" data-v-8b1308b4><img class=\"img2\" src=\"" + _imports_2 + "\" data-v-8b1308b4><img class=\"img1\" src=\"" + _imports_3 + "\" data-v-8b1308b4><img class=\"img3\" src=\"" + _imports_4 + "\" data-v-8b1308b4><div class=\"t1\" data-v-8b1308b4>更简单的场景创作</div><div class=\"t2\" data-v-8b1308b4>3D场景地图，可视化交互智能创作，所“建”即所得</div></div><div class=\"m4\" data-v-8b1308b4><img class=\"img2\" src=\"" + _imports_5 + "\" data-v-8b1308b4><img class=\"img1\" src=\"" + _imports_6 + "\" data-v-8b1308b4><div class=\"t1\" data-v-8b1308b4>AI创作功能</div><div class=\"t2\" data-v-8b1308b4>AI一键生成内容素材，畅享无限创作</div></div><div class=\"m3\" data-v-8b1308b4><div data-v-8b1308b4><div class=\"m3-icons\" data-v-8b1308b4><img src=\"" + _imports_7 + "\" data-v-8b1308b4><img src=\"" + _imports_8 + "\" data-v-8b1308b4><img src=\"" + _imports_9 + "\" data-v-8b1308b4></div><div class=\"t1\" data-v-8b1308b4>更多平台支持应用</div><div class=\"t2\" data-v-8b1308b4>XR/VR眼镜、移动端APP、小程序AR、Web AR</div></div><div data-v-8b1308b4><div class=\"m3-r\" data-v-8b1308b4><img src=\"" + _imports_10 + "\" data-v-8b1308b4><img src=\"" + _imports_11 + "\" data-v-8b1308b4></div><div class=\"t1\" data-v-8b1308b4>更强的内容扩展性</div><div class=\"t2\" data-v-8b1308b4>数字多媒体动画、特效手势互动、3D数字人</div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_18, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "混空Studio使用教程", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-tips" }, "AI+AR元宇宙创作智能体，轻松实现AR创作与开发", -1)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solutionBannerList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass((solutionActiveIndex.value == index ? 'active' : '') + (index == 99 ? ' no-list' : '') + (index == 1 ? ' op-list' : '')),
              onClick: ($event: any) => (changeSolution(Number(index)))
            }, [
              _createElementVNode("img", {
                src: solutionActiveIndex.value == index ? item.a_url : item.url
              }, null, 8, _hoisted_22),
              _createElementVNode("span", null, _toDisplayString(item.title), 1),
              (solutionActiveIndex.value == index)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (e, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (solutionActiveIndex.value == index)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                : _createCommentVNode("", true)
            ], 10, _hoisted_21))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solutionBannerList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "explanation-video",
              style: _normalizeStyle({ opacity: solutionActiveIndex.value == index ? 1 : 0 }),
              key: index
            }, [
              (item.i_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.i_url
                  }, null, 8, _hoisted_25))
                : _createCommentVNode("", true),
              (item.v_url)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    src: item.v_url,
                    autoplay: "",
                    loop: "",
                    muted: "",
                    playsinline: "",
                    "webkit-playsinline": ""
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true)
            ], 4))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title deep" }, "按需选择 灵活购买", -1)),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title-tips deep" }, "混空Studio产品体系", -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createStaticVNode("<div data-v-8b1308b4>空间AR服务</div><div class=\"suv-title2\" data-v-8b1308b4>标准服务包含</div><div class=\"service-content\" data-v-8b1308b4><div data-v-8b1308b4><span data-v-8b1308b4>定位面积</span><span data-v-8b1308b4>服务时长</span><span data-v-8b1308b4>并发数量</span><span data-v-8b1308b4>作品数量</span></div><div data-v-8b1308b4><span data-v-8b1308b4>小程序访问次数</span><span data-v-8b1308b4>素材空间容量</span></div></div><div class=\"suv-title2\" data-v-8b1308b4>功能包含</div><div class=\"function-box\" data-v-8b1308b4><div data-v-8b1308b4>全平台空间定位功能</div><div data-v-8b1308b4>XR眼镜端</div><div data-v-8b1308b4>移动端</div><div data-v-8b1308b4>微信小程序</div></div>", 5)),
          _createElementVNode("div", {
            class: "contact-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toContact()))
          }, "立即咨询"),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的作品实际情况，购买标准服务（支持按需扩展单项），详询混空商务", -1))
        ]),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createStaticVNode("<div data-v-8b1308b4>单点AR服务</div><div class=\"suv-title2\" data-v-8b1308b4>标准服务包含</div><div class=\"service-content\" data-v-8b1308b4><div data-v-8b1308b4><span data-v-8b1308b4>单点AR识别</span><span data-v-8b1308b4>服务时长</span><span data-v-8b1308b4>作品数量</span></div><div data-v-8b1308b4><span data-v-8b1308b4>小程序访问次数</span><span data-v-8b1308b4>素材空间容量</span></div></div><div class=\"suv-title2\" data-v-8b1308b4>功能包含</div><div class=\"function-box\" data-v-8b1308b4><div data-v-8b1308b4>平面AR</div><div data-v-8b1308b4>图像AR</div><div data-v-8b1308b4>单场景AR</div><div data-v-8b1308b4>人脸AR</div><div data-v-8b1308b4>身体AR</div><div data-v-8b1308b4>手势AR</div></div>", 5)),
          _createElementVNode("div", {
            class: "contact-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toContact()))
          }, "立即咨询"),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "contact-tips" }, "可根据您的作品实际情况，购买标准服务（支持按需扩展单项），详询混空商务", -1))
        ])
      ])
    ]),
    (_unref(store).state.contactUsTop)
      ? (_openBlock(), _createBlock(ContactUs, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})